import {Outlet} from "react-router-dom";
import { useSelector } from "react-redux";
import Error404 from "./Error404";
import NavbarDesktop from "./NavbarDesktop";
import NavbarMobile from "./NavbarMobile";

function Layout() {
	const signedIn = useSelector(state => state.user.signedIn);

	if (signedIn) {
		return (
			<>
				<NavbarDesktop />
				<NavbarMobile />
	
				<Outlet />
			</>
		)
	} else {
		return <Error404 />
	}
}

export default Layout;